import Flex from "@/components/flex"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { unitsStore } from "@/routes/apt/[apt_code]/units/units-store"
import { usageChartStore } from "@/routes/apt/[apt_code]/units/_components/usage/usage-chart-store"
import UsageChartView from "@/routes/apt/[apt_code]/units/_components/usage/desktop/usage-chart-view"
import UsageCalendarView from "@/routes/apt/[apt_code]/units/_components/usage/mobile/usage-calendar-view"
import WeekdayCompareChartView from "@/routes/apt/[apt_code]/units/_components/weekday/weekday-compare-chart-view"
import { weekdayCompareChartStore } from "@/routes/apt/[apt_code]/units/_components/weekday/weekday-compare-chart-store"
import { weekdayDetailChartStore } from "@/routes/apt/[apt_code]/units/_components/weekday/weekday-detail-chart-store"
import ClockView from "@/routes/apt/[apt_code]/units/_components/clock/clock-view"
import InsightView from "@/routes/apt/[apt_code]/units/_components/insight/insight-view"
import { clockStore } from "@/routes/apt/[apt_code]/units/_components/clock/clock-store"
import useIsMobile from "@/hooks/use-is-mobile"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { calcStartDate } from "@/utils/calc-start-date-util"
import dayjs from "dayjs"
import { langStore } from "@/stores/lang-store"
import SummaryView from "./_components/summary/Summary-view"
import { summaryStore } from "./_components/summary/summary-store"
import { unitsBundle } from "./units-const"

const UnitsPage = () => {
  const { lang } = langStore()

  const [searchParams] = useSearchParams()
  const resource = searchParams.get("resource") ?? "water"
  const dong = searchParams.get("dong") ?? ""
  const ho = searchParams.get("ho") ?? ""

  const isMobile = useIsMobile()
  const { ended_at } = aptSearchStore((s) => s.pickApt)
  useEffect(() => {
    if (!dong || !ho) return

    if (!ended_at) return

    summaryStore.getState().apiGetUsageContext({ dong, ho, resource })

    if (isMobile) {
      const oneMonth = calcStartDate(ended_at, "months")

      const start = dayjs(oneMonth).startOf("month").format("YYYY-MM-DD")
      usageChartStore
        .getState()
        .apiGetUsage({ dong, ho, startDate: start, endDate: ended_at, resource })
    } else {
      usageChartStore.getState().apiGetUsage({ dong, ho, resource })
    }

    weekdayCompareChartStore.getState().apiGetWeekdayCompare({ dong, ho, resource })
  }, [resource, dong, ho, isMobile, ended_at])

  useEffect(() => {
    return () => {
      unitsStore.getState().reset()
      summaryStore.getState().reset()
      usageChartStore.getState().reset()
      clockStore.getState().reset()
      weekdayCompareChartStore.getState().reset()
      weekdayDetailChartStore.getState().reset()
    }
  }, [])

  return isMobile && (!dong || !ho) ? (
    <div className="flex flex-1 items-center justify-center min-h-80">
      <div className="text-center">
        <p className="text-base font-medium text-gray-500">
          {unitsBundle.emptyMessage[lang].title}
        </p>

        <p className="mt-1 text-sm text-gray-400">{unitsBundle.emptyMessage[lang].description}</p>
      </div>
    </div>
  ) : (
    <Flex className="flex-col w-full md:h-full overflow-visible md:overflow-hidden">
      <Flex className="flex-1">
        <SummaryView className="w-full md:w-fit py-0 md:py-4" />
        <UsageChartView className={"flex flex-1 flex-col gap-4 min-w-0"} />
      </Flex>

      <UsageCalendarView />

      <Flex className="min-h-0 md:flex-row flex-col">
        <WeekdayCompareChartView className="flex-1 flex flex-col md:min-w-180 md:max-w-260" />

        <ClockView className="flex flex-col p-4" />

        <InsightView className="md:flex-1 flex flex-col p-4" />
      </Flex>
    </Flex>
  )
}

export default UnitsPage
